import { styled, css } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'
import { Identity } from './Identity'

export const ButtonsSeparator = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`

export const ExistingUserFormFields = styled.div`
  width: 100%;

  ${plume.RoundButton} {
    display: none;
  }
`

export const ExistingUserFormBlock = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${plume.CheckboxField} {
    margin: 0;
  }

  ${plume.Link} {
    align-self: center;
    margin: 16px 0 24px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    flex-direction: row;

    ${plume.CheckboxField} {
      margin: 0 0 24px;
    }

    ${plume.Link} {
      align-self: initial;
      margin: 0;
    }
  }
`

export const ExistingUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  ${plume.styles.copy.M.light} {
    width: 100%;
    margin: 0 0 11px;
  }

  ${plume.TextField} {
    margin: 0 0 20px;
  }

  ${plume.TextField}, ${ExistingUserFormBlock} {
    width: 100%;
  }

  ${plume.RoundButton} {
    margin: 0 0 10px;
  }

  ${plume.styles.copy.XS.regular} {
    color: ${plume.COLORS.TEXT_TERTIARY};
    text-transform: uppercase;
  }
`

export const HorizontalRuler = styled.hr`
  border: 0;
  border-top: 1px solid ${plume.COLORS.BORDER_PRIMARY};
  display: block;
  height: 1px;
  padding: 0;
  position: absolute;
  top: 42%;
  width: 90%;
  z-index: 1;
`

export const OrLabel = styled(plume.styles.copy.M.light)`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  padding: 0 10px;
  text-transform: lowercase;
  z-index: 2;
`

export const ResetButton = styled(plume.LinkAsButton).attrs({ kind: 'secondary' })<{
  $adjustForHint?: boolean
  $adjustForCompactMode?: boolean
}>`
  font-weight: 600; /* HACK: Irregular font manipulation. We'll be adding copy.S.semiBold, so this is just by anticipation. */
  position: absolute;
  right: -16px;
  top: 16px;

  ${({ $adjustForCompactMode = false }) => {
    if ($adjustForCompactMode) {
      return css`
        top: -32px;
      `
    }
  }};

  ${({ $adjustForHint = false }) => {
    if (!$adjustForHint) {
      return css`
        padding: 0;
        right: 0;
        top: 0;
      `
    }
  }};
`

export const ThirdPartyAuthExistingUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  ${plume.styles.copy.M.light} {
    width: 100%;
    margin: 0 0 11px;
  }

  ${plume.TextField} {
    width: 100%;
    position: relative;
  }

  ${plume.Link} {
    position: absolute;
    top: 0;
    right: 0;
  }

  ${plume.SocialButton} {
    margin: 30px 0 10px;
  }

  ${plume.Callout} {
    margin: 0 0 10px;
  }
`

export const ThirdPartyAuthKnownUserForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${Identity} {
    width: 100%;
    padding: 20px 0;
  }

  ${plume.SocialButton} {
    margin: 0 0 10px;
  }
`

export const IdentityBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const IdentityGroup = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  margin-left: 18px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    flex-direction: row;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    flex-direction: column;
    margin-left: 18px;
  }
`

export const IdentitySmallText = styled(plume.styles.copy.S.regular)`
  margin: 0;
`

export const IdentityUsernameWrapper = styled(plume.styles.copy.Base)`
  font-size: 17px; // HACK: Irregular font manipulation
  line-height: 22px;
`

export const KnownUserBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;

  ${plume.Link} {
    font-size: 13px;
  }
`

export const NewUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  // FIXME: Too generic…

  ${plume.styles.copy.M.light} {
    margin: 0 0 11px;
  }

  ${plume.TextField}, ${plume.PasswordField}, ${plume.CheckboxField} {
    margin: 0 0 20px;
  }

  ${plume.TextField}, ${plume.PasswordField} {
    width: 100%;
  }

  ${plume.CheckboxField} {
    ${plume.styles.field.Title} {
      color: ${plume.COLORS.TEXT_TERTIARY};
    }
  }

  ${plume.styles.button.CallToAction} {
    margin: 0 0 10px;
  }

  ${plume.styles.copy.XS.regular} {
    color: ${plume.COLORS.TEXT_TERTIARY};
    margin: 10px 0 20px;
    text-transform: uppercase;
  }

  ${OrLabel} {
    color: ${plume.COLORS.PRIMARY_SAND_500};
    margin: 16px 0;
  }

  ${plume.SocialButton} + ${plume.SocialButton} {
    margin-top: 8px;
  }
`

export const UluleKnownUserForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${plume.TextField} {
    &::placeholder {
      color: transparent;
    }
  }

  ${plume.TextField}, ${KnownUserBlock} {
    margin: 0 0 20px;
  }

  ${plume.TextField}, ${KnownUserBlock}, ${Identity} {
    width: 100%;
  }

  ${Identity} {
    margin-bottom: 20px;
  }

  ${plume.RoundButton} {
    margin: 0 0 10px;
  }

  ${plume.styles.copy.XS.regular} {
    color: ${plume.COLORS.TEXT_TERTIARY};
    text-transform: uppercase;
  }

  ${plume.SocialButton} + ${plume.SocialButton} {
    margin-top: 8px;
  }
`

export const UnknownUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  // FIXME: Too generic…

  ${plume.styles.copy.M.light} {
    margin: 0 0 11px;
  }

  ${plume.TextField} {
    margin: 0 0 16px;
    width: 100%;

    &::placeholder {
      color: transparent;
    }
  }

  ${plume.RoundButton} {
    margin: 0 0 10px;
  }

  ${OrLabel} {
    color: ${plume.COLORS.PRIMARY_SAND_500};
    margin: 16px 0;
  }

  ${plume.SocialButton} + ${plume.SocialButton} {
    margin-top: 8px;
  }

  ${plume.Link} {
    margin-top: 8px;
  }
`

export const Wrapper = styled.div<{ $compactMode: boolean }>`
  ${({ $compactMode }) => {
    if ($compactMode) {
      return css`
        ${plume.TextField} label {
          display: none;
        }

        ${plume.Link} {
          margin: 0;
        }

        // UnknownUserForm

        ${UnknownUserForm} {
          ${plume.TextField} {
            margin: 0 0 8px;
            width: 100%;
          }

          @media screen and ${plume.BREAKPOINTS.LAPTOP} {
            align-items: flex-start;
            flex-direction: row;
            justify-content: space-between;

            ${plume.styles.copy.M.light} {
              margin: 0;
            }

            ${plume.TextField} {
              margin: 0;
              margin-right: 16px;
            }

            ${plume.RoundButton} {
              margin: 0;
              width: 471px;
              margin-top: 7px;
            }
          }
        }

        // Existing User

        ${ExistingUserForm} {
          ${plume.RoundButton} {
            display: none;
          }

          ${ExistingUserFormFields} {
            width: 100%;

            ${plume.RoundButton} {
              display: block;
            }
          }

          @media screen and ${plume.BREAKPOINTS.LAPTOP} {
            ${plume.TextField} {
              width: calc(50% - 7px);
              margin-right: 7px;
            }

            ${ExistingUserFormFields} {
              display: flex;
              justify-content: space-between;
              width: 100%;
            }

            ${plume.RoundButton} {
              width: 59%;
              margin-left: 10px;
            }

            ${ExistingUserFormBlock} {
              width: 100%;

              ${plume.CheckboxField} {
                margin-bottom: 0;
              }
            }

            ${plume.Link} {
              ${plume.styles.copy.styles.S.regular};
              color: ${plume.COLORS.TEXT_TERTIARY}; // HACK: Irregular font manipulation
            }
          }
        }
      `
    }
  }}
`

export const ResetPasswordForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  // FIXME: Too generic…

  ${plume.styles.field.Description} {
    margin: 0 0 11px;
  }

  ${plume.TextField}, ${plume.PasswordField} {
    margin: 0 0 16px;
    width: 100%;

    &::placeholder {
      color: transparent;
    }
  }

  ${plume.RoundButton} {
    margin: 0 0 10px;
  }

  ${OrLabel} {
    color: ${plume.COLORS.PRIMARY_SAND_500};
    margin: 16px 0;
  }

  ${plume.SocialButton} + ${plume.SocialButton} {
    margin-top: 8px;
  }

  ${plume.Link} {
    margin-top: 8px;
  }
`
export const StyledBanner = styled(plume.Banner)`
  text-align: left;
  margin-top: 8px;
`
